import { Page } from '../../Page';
import styles from './MessageBoxes.module.css';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectMessage, selectMessageBoxAction, MessageBoxAction } from './messageBoxSlice';
import { useNavigate } from 'react-router-dom';
import { removeEventUserAsync } from '../currentEventUsers/currentEventUsersSlice';
import { selectCurrentPartyEvent } from '../currentPartyEvent/currentPartyEventSlice';
import { useAuth0 } from '@auth0/auth0-react';
import { selectAttendeeEmail } from '../currentAttendee/currentAttendeeSlice';

export function MessageBox () {
    const message = useAppSelector (selectMessage)
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
    const messageBoxAction = useAppSelector(selectMessageBoxAction)
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    const attendeeEmail = useAppSelector(selectAttendeeEmail)
    const navigate = useNavigate ()
    const dispatch = useAppDispatch ()
    return (
        <Page>
            <div className={styles.MessageBox}>
            <p> {message ?? ''}</p>
                <button className={styles.NoButton} onClick={() => {
                    navigate(-1)
                }}>No</button>
                <button className={styles.YesButton} onClick={async(e) => {
                    e.stopPropagation()
                    switch (messageBoxAction) {
                        case MessageBoxAction.GoBack : 
                             navigate(-2)
                             break 
                        case MessageBoxAction.GoToCurrentsPartyEvents :
                            navigate('/currentPartyEvent')
                             break
                         case MessageBoxAction.GoHome :
                             navigate('/')
                             break
                        case MessageBoxAction.DeleteAttendee :
                            if (isAuthenticated) {
                            try {   
                                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                                }})
                                    if (currentPartyEvent?.id != null && attendeeEmail )  {
                                dispatch(removeEventUserAsync( {
                                        partyEventId: currentPartyEvent.id,
                                             email: attendeeEmail,
                                             token: accessToken 
                                })) 
                                navigate(-1)
                            }
                            }
                            catch (error) { 
                                //TODO: Handle correctly
                            }
                            }
                            break
                    }
                }}>Yes</button>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
            </div>
        </Page>
    )
}